export default "__VITE_ASSET__CFi7Oq5H__"